import type { ExpertTrialBalanceColumnDef, ExpertTrialBalanceColumnId } from '../hooks/useExpertTrialBalanceColumns'

export const getVisibleTrialBalanceColumns = (
  columns: ExpertTrialBalanceColumnDef[],
  hiddenColumnIds: ExpertTrialBalanceColumnId[],
): ExpertTrialBalanceColumnDef[] => {
  if (hiddenColumnIds.length === 0) {
    return columns
  }

  const hiddenColumnIdSet = new Set(hiddenColumnIds)

  return columns.filter((column) => !hiddenColumnIdSet.has(column.id))
}
